import { defineMessage } from 'services/localization';

export const messages = {
    label: defineMessage('group_name'),
    placeholder: defineMessage('enter_a_group_name'),
    save: defineMessage('save'),
    requiredErrorMessage: defineMessage('name_is_required'),
    conflictErrorMessage: defineMessage('another_group_already_exists_with_this_name'),
};
